class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.customCartCountdownInterval = null;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

this.addEventListener(
  'change',
  (event) => {
    const target = event.target;

    if (!target.matches('[data-custom-cart-variant-option]')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    this.handleVariantChange(target);
  },
  true
);

this.setHeaderCartIconAccessibility();
this.initFloatingCartButton();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
  this.classList.add('animate', 'active');
  this.startPromoCountdown();
});

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    this.lockBodyScroll();

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    this.unlockBodyScroll();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

 renderContents(parsedState) {
  const itemCount =
    Number(parsedState.item_count || 0);

  const isEmpty =
    itemCount === 0;

  /*
   * A classe is-empty pertence ao
   * <cart-drawer>, não ao .drawer__inner.
   */
  this.classList.toggle(
    'is-empty',
    isEmpty
  );

  this.productId =
    parsedState.id ||
    parsedState.items?.[0]?.id ||
    null;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
initFloatingCartButton() {
  const floatingButton = document.querySelector('[data-custom-cart-floating-button]');
  if (!floatingButton) return;
  if (floatingButton.dataset.floatingCartInitialized === 'true') return;

  floatingButton.dataset.floatingCartInitialized = 'true';

  const getProductSubmitButton = () => {
    const productForm =
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    return (
      productForm?.querySelector('[type="submit"]') ||
      document.querySelector('button[name="add"]')
    );
  };

  const hideFloatingButton = () => {
    floatingButton.classList.remove('is-visible');
  };

  const updateFloatingButton = () => {
    if (window.innerWidth > 749) {
      hideFloatingButton();
      return;
    }

    if (document.body.classList.contains('cart-drawer-open')) {
      hideFloatingButton();
      return;
    }

    const submitButton = getProductSubmitButton();

    if (!submitButton) {
      hideFloatingButton();
      return;
    }

    const buttonPosition = submitButton.getBoundingClientRect();

    // Só mostra quando o botão original já saiu da tela para cima
    const originalButtonDisappearedAbove = buttonPosition.bottom <= 0;

    if (originalButtonDisappearedAbove) {
      floatingButton.classList.add('is-visible');
    } else {
      hideFloatingButton();
    }
  };

  floatingButton.addEventListener('click', () => {
    const submitButton = getProductSubmitButton();

    if (submitButton && !submitButton.disabled) {
      submitButton.click();
      return;
    }

    this.open(floatingButton);
  });

  window.addEventListener('scroll', updateFloatingButton, { passive: true });
  window.addEventListener('resize', updateFloatingButton);

  updateFloatingButton();
}

getSelectedVariant(selectorGroup) {
  const variantsScript = selectorGroup.querySelector('[data-product-variants-json]');
  const selects = selectorGroup.querySelectorAll('[data-custom-cart-variant-option]');

  if (!variantsScript || !selects.length) return null;

  let variants = [];

  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    console.error('Erro ao ler variantes:', error);
    return null;
  }

  const selectedOptions = Array.from(selects).map((select) => select.value);

  return variants.find((variant) => {
    return selectedOptions.every((value, index) => variant.options[index] === value);
  });
}

getCartAddUrl() {
  if (typeof routes !== 'undefined' && routes.cart_add_url) {
    return routes.cart_add_url;
  }

  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  return `${root}cart/add.js`;
}

getCartChangeUrl() {
  if (typeof routes !== 'undefined' && routes.cart_change_url) {
    return routes.cart_change_url;
  }

  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  return `${root}cart/change.js`;
}

async handleVariantChange(select) {
  const selectorGroup = select.closest('[data-custom-cart-variant-selectors]');
  if (!selectorGroup) return;

  const newVariant = this.getSelectedVariant(selectorGroup);
  const currentVariantId = Number(selectorGroup.dataset.currentVariantId);
  const oldLineKey = selectorGroup.dataset.lineKey;
  const oldLineIndex = Number(selectorGroup.dataset.lineIndex);
  const quantity = Number(selectorGroup.dataset.quantity || 1);

  if (!newVariant) {
    alert('Essa combinação não existe.');
    return;
  }

  if (!newVariant.available) {
    alert('Essa variação está esgotada.');
    return;
  }

  if (Number(newVariant.id) === currentVariantId) return;

  await this.replaceCartVariant({
    newVariantId: newVariant.id,
    oldVariantId: currentVariantId,
    oldLineKey,
    oldLineIndex,
    quantity,
    selectorGroup,
  });
}

async replaceCartVariant({ newVariantId, oldVariantId, oldLineKey, oldLineIndex, quantity, selectorGroup }) {
  const selects = selectorGroup.querySelectorAll('[data-custom-cart-variant-option]');
  const sections = this.getSectionsToRender().map((section) => section.id);

  selects.forEach((select) => {
    select.disabled = true;
  });

  try {
    const removeBody = Number.isFinite(oldLineIndex) && oldLineIndex > 0
      ? {
          line: oldLineIndex,
          quantity: 0,
        }
      : {
          id: oldLineKey,
          quantity: 0,
        };

    const removeResponse = await fetch(this.getCartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(removeBody),
    });

    const removeState = await removeResponse.json();

    if (!removeResponse.ok || removeState.status) {
      throw new Error(removeState.description || removeState.message || 'Não foi possível remover a variação anterior.');
    }

    const addResponse = await fetch(this.getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: Number(newVariantId),
        quantity: Math.max(1, quantity),
        sections,
        sections_url: window.location.pathname,
      }),
    });

    const updatedState = await addResponse.json();

    if (!addResponse.ok || updatedState.status) {
      await fetch(this.getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: Number(oldVariantId),
          quantity: Math.max(1, quantity),
        }),
      });

      throw new Error(updatedState.description || updatedState.message || 'Não foi possível adicionar a nova variação.');
    }

    this.renderContents(updatedState);
  } catch (error) {
    console.error(error);
    alert(error.message || 'Não foi possível trocar a variação.');

    selects.forEach((select) => {
      select.disabled = false;
    });
  }
}

lockBodyScroll() {
  if (document.body.classList.contains('cart-drawer-scroll-locked')) return;

  const scrollY = window.scrollY || window.pageYOffset || 0;

  document.body.dataset.cartDrawerScrollY = String(scrollY);
  document.body.classList.add('overflow-hidden', 'cart-drawer-open', 'cart-drawer-scroll-locked');

  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

unlockBodyScroll() {
  const scrollY = Number(document.body.dataset.cartDrawerScrollY || 0);

  document.body.classList.remove('overflow-hidden', 'cart-drawer-open', 'cart-drawer-scroll-locked');

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';

  delete document.body.dataset.cartDrawerScrollY;

  window.scrollTo(0, scrollY);
}
startPromoCountdown() {
  const timerElement = this.querySelector('[data-custom-cart-countdown]');
  const promoBar = this.querySelector('.custom-cart-promo-bar');

  if (this.customCartCountdownInterval) {
    clearInterval(this.customCartCountdownInterval);
    this.customCartCountdownInterval = null;
  }

  if (!timerElement || !promoBar) return;
  if (promoBar.dataset.customCartTimerEnabled !== 'true') return;

  const minutes = Number(promoBar.dataset.customCartTimerMinutes || 10);
  const endTime = Date.now() + Math.max(1, minutes) * 60 * 1000;

  const updateTimer = () => {
    const remainingSeconds = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
    const displayMinutes = Math.floor(remainingSeconds / 60);
    const displaySeconds = remainingSeconds % 60;

    timerElement.textContent = `${String(displayMinutes).padStart(2, '0')}:${String(displaySeconds).padStart(2, '0')}`;

    if (remainingSeconds <= 0 && this.customCartCountdownInterval) {
      clearInterval(this.customCartCountdownInterval);
      this.customCartCountdownInterval = null;
    }
  };

  updateTimer();
  this.customCartCountdownInterval = setInterval(updateTimer, 1000);
}
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
